import React, { useEffect, useState } from "react";
import { IoArrowUpCircleOutline } from "react-icons/io5";
import "bootstrap/dist/css/bootstrap.min.css";

import founder from "../Images/Founder/WhatsApp Image 2025-04-21 at 12.11.07 PM.jpeg";
import founder1 from "../Images/Founder/WhatsApp Image 2025-04-21 at 12.11.12 PM.jpeg";
import founder2 from "../Images/Founder/WhatsApp Image 2025-04-21 at 12.11.14 PM.jpeg";
import founder3 from "../Images/Founder/WhatsApp Image 2025-04-21 at 12.11.15 PM (1).jpeg";
import founder4 from "../Images/Founder/WhatsApp Image 2025-04-21 at 12.11.15 PM (2).jpeg";
import founder5 from "../Images/Founder/WhatsApp Image 2025-04-21 at 12.11.15 PM.jpeg";
import founder6 from "../Images/Founder/WhatsApp Image 2025-04-21 at 12.11.16 PM (1).jpeg";
import founder7 from "../Images/Founder/WhatsApp Image 2025-04-21 at 12.11.16 PM (2).jpeg";
import { BASEAPIURL, token } from "../env";

const founderImages = [founder, founder1, founder2, founder3, founder4, founder5, founder6, founder7];

export default function Founder() {
  const [past, setPast] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  useEffect(() => {
    scrollToTop();
    fetchPastData();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const fetchPastData = async () => {
    try {
      const res = await fetch(`${BASEAPIURL}/GetAllOfficeBearers`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tokenData: token }),
      });

      const json = await res.json();

      // Extract nested structure (assuming it's an array)
      const result = Array.isArray(json?.data)
        ? json.data
        : json?.data
          ? [json.data]
          : [];

      const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        return isNaN(date) ? "" : date.toISOString().split("T")[0]; // YYYY-MM-DD
      };

      const newPast = result.map((item, index) => ({
        PastId: index + 1,
        President: item?.President ?? "-",
        Secretary: item?.Secretary ?? "-",
        FromDate: formatDate(item?.FromDate),
        ToDate: formatDate(item?.ToDate),
      }));

      setPast(newPast);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching office bearers:", err);
      setLoading(false);
    }
  };


  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const filteredPast = past.filter(
    (item) =>
      item.President.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.Secretary.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredPast.length / itemsPerPage);
  const paginatedData = filteredPast.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  

  return (
    <div className="container py-4">
      <h4 className="text-start text-primary text-decoration-underline mb-4">
        Founder / Past Members
      </h4>

      <div className="row g-4 mb-4">
        {founderImages.map((item, index) => (
          <div key={index} className="col-6 col-md-3 d-flex justify-content-center">
            <img
              src={item}
              className="img-fluid rounded shadow"
              style={{ maxWidth: "150px", height: "auto" }}
              alt={`Founder ${index + 1}`}
            />
          </div>
        ))}
      </div>

      <input
        type="text"
        className="form-control mb-3"
        placeholder="Search President or Secretary..."
        value={searchTerm}
        onChange={handleSearch}
      />

      <div className="table-responsive">
        <table className="table table-bordered table-striped text-center fw-semibold">
          <thead className="table-primary">
            <tr>
              <th>No.</th>
              <th>President</th>
              <th>Secretary</th>
              <th>From</th>
              <th>To</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5">Loading...</td>
              </tr>
            ) : paginatedData.length > 0 ? (
              paginatedData.map((item, index) => (
                <tr key={item.OfficeBearersID}>
                  <td>{index + 1}</td>
                  <td>{item.President}</td>
                  <td>{item.Secretary}</td>
                  <td>{formatDate(item.FromDate)}</td>
                  <td>{formatDate(item.ToDate)}</td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No past records found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <nav className="d-flex justify-content-center mt-3 align-center">
        <ul className="pagination">
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
              Previous
            </button>
          </li>
          <li className="page-item disabled">
            <span className="page-link">
              Page {currentPage} of {totalPages}
            </span>
          </li>
          <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
              Next
            </button>
          </li>
        </ul>
      </nav>

      <button
        className="btn btn-pink position-fixed bottom-0 end-0 m-4 rounded-circle p-2 shadow"
        onClick={scrollToTop}
      >
        <IoArrowUpCircleOutline className="fs-3" />
      </button>
    </div>
  );
}
